import { render, staticRenderFns } from "./ChangeOfAddress.vue?vue&type=template&id=6f6cddf4&scoped=true&"
import script from "./ChangeOfAddress.vue?vue&type=script&lang=js&"
export * from "./ChangeOfAddress.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfAddress.vue?vue&type=style&index=0&id=6f6cddf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6cddf4",
  null
  
)

export default component.exports